import { LeftBar } from "../../components";
import Main from "./component.main";
import store from "./script.store";
const Superadmin = { LeftBar, Main, store };
export default Superadmin;
